import styled from 'styled-components'
import Button from 'antd/lib/button'
import Spin from 'antd/lib/spin'
import Skeleton from 'antd/lib/skeleton'
import BackTop from 'antd/lib/back-top'
import {
  WHITE,
  AUBERGINE,
  GRAY_SOFT,
  BLACK,
  GRAY_LIGHTEST,
  RED,
  GREEN,
  GRAY_DARK,
  BLUE
} from '../../theme/colors'
import { AVENIR_MEDIUM, AVENIR_NEXT } from '../../theme/fonts'

interface DivProps {
  loading?: boolean
  fullSize?: boolean
  topPosition?: number
  secondary?: boolean
  width?: string
  order?: number
}

export const Container = styled.div`
  transition: all 0.5s ease;
  z-index: 2;
  min-height: ${({ loading }: DivProps) => (loading ? '882px' : '120vh')};
  max-width: 1680px;
  margin: 0 auto;
  opacity: ${({ loading }: DivProps) => (loading ? '0' : '1')};
`

export const BackTopStyled = styled(BackTop)`
  &.ant-back-top {
    left: calc(50% - 122px) !important;
    bottom: 32px !important;
  }
  #btnContainer {
    max-width: 328px;
    width: 100%;
    padding-inline: 14px;
  }
  #btnStart {
    display: flex;
    align-items: center;
    white-space: nowrap;
    background: #1e1e1e;
    color: white;
    padding: 7px 22px;
    padding-left: 20px;
    border-radius: 25px;
    font-weight: 500;
    font-family: Avenir;
    font-size: 17px;
    width: fit-content;
    border: 2px solid white;
    box-shadow: 0px 2px 4px -1px #6d6c6c;
    transition: background .25s, color .25s;
    img {
      margin-right: 10px;
      width: 19px;
      margin-top: -2px;
    }
    :hover {
      background: white;
      outline: 1px solid black;
      color: black;
      cursor: pointer;
    }
  }
  @media (max-width: 698px) {
    #btnStart {
      font-size: 13px;
      img {
        width: 14px;
      }
    }
    &.ant-back-top {
      left: calc(50% - 98px) !important;
      bottom: 12px !important;
    }
  }
`

export const HomeHeader = styled.div`
  color: ${WHITE};
  font-size: 24px;
  padding: 20px;
`

export const TeamStoreLink = styled.div`
  max-width: 150px;
  color: ${GRAY_DARK};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-weight: 500;
  font-family: Avenir;
`

export const StoreIcon = styled.img`
  max-width: 12px;
  margin-top: -2px;
  margin-right: 8px;
  filter: brightness(5) contrast(0.5);
`

export const SearchBackground = styled.img`
  object-fit: cover;
  width: 100%;
  cursor: pointer;
`

export const SearchContainer = styled.div`
  position: relative;
  text-align: center;
`

export const DynamicWidth = styled.div`
  width: ${({ width }: DivProps) => width ? width : '100%'};
  vertical-align: middle;
  display: inline-block;
  @media (max-width: 668px) {
    width: ${({ secondary }: DivProps) => secondary ? '50%' : '100%'};
    .infoLabl {
      position: ${({ secondary }: DivProps) => secondary ? 'inherit' : 'absolute'};
      background: ${({ secondary }: DivProps) => secondary ? 'white' : '#ffffffe3'};
    }
  }
`

export const HelpContainer = styled.div`
  text-align: center;

  @media (min-width: 320px) and (max-width: 767px) {
    display: none;
  }
`

export const Spinner = styled(Spin)`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  display: flex;
`

export const ImageSkeleton = styled.div`
  width: ${({ fullSize }: DivProps) => (fullSize ? '100%' : '48%')};
  border-radius: 7px;
  height: 262px;
  margin-top: 24px;
  margin-bottom: 18px;
  background: #f1f1f1;
  @media (max-width: 768px) {
    margin-top: ${({ fullSize }: DivProps) => (fullSize ? '0' : '24px')};
  }
`

export const ImageRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`

export const RedirectDiv = styled.div`
  display: flex;
  flex-flow: column;
  width: 100vw;
  position: fixed;
  height: 100vh;
  justify-content: center;
  align-items: center;
`

export const JakrooLogo = styled.img`
  max-width: 239px;
  width: 100%;
  margin-bottom: 32px;
`

export const LabelRedirect = styled.div`
  margin-bottom: 44px;
`

export const SkeletonDiv = styled(Skeleton)`
  margin-left: -77px;
  li {
    background: #f1f1f1 !important;
  }
`

export const LoadingContainer = styled.div`
  justify-content: center;
  flex-flow: column;
  width: 100%;
  transition: all .25s ease;
  padding: 0 26px;
  position: absolute;
  top: 103px;
  z-index: 1;
  display: ${({ loading }: DivProps) => (loading ? 'flex' : 'none')}
  opacity: ${({ loading }: DivProps) => (loading ? '1' : '0')}
  align-items: center;
`

export const NeedHelp = styled.div`
  color: ${WHITE};
  font-size: 14px;
  height: 19px;
  line-height: 19px;
  margin: 17px 0 5px 0;
`

export const GetStartedDiv = styled.div`
  text-align: center;
  padding: 40px 0;
  background: ${WHITE};
  position: relative;
  @media (max-width: 767px) {
    padding: 10px 0;
  }
`

export const GetStartedButton = styled(Button)`
  border-radius: 3px;
  font-size: 16px;
  height: 46px;
  line-height: 22px;
  width: 100%;
  max-width: fit-content;
  color: white;
  font-family: Avenir;
  border: none;
  background: ${BLUE};
  box-shadow: 1px 1px 3px 1px #c4c4c4;
  @media (max-width: 767px) {
    white-space: break-spaces;
    padding: 8px;
    height: auto;
    margin: auto 6px;
  }
  ${({ secondary }: DivProps) => secondary ? `
    animation: fade-in 1s cubic-bezier(0.390, 0.575, 0.565, 1.000) 2 both;
    @keyframes fade-in {
      0% {
        opacity: 1;
        background: ${BLUE};
      }
      50% {
        opacity: 0.60;
        background: ${WHITE};
        color: ${BLUE};
      }
      100% {
        opacity: 1;
        background: ${BLUE};
      }
    }
  ` : ''}
`

export const OrDiv = styled.div`
  display: flex;
  justify-content: center;
  font-size: 30px;
  padding: 12px 0;
  background: white;
  @media (max-width: 767px) {
    font-size: 22px;
    padding: 6px 0;
  }
`

export const OrText = styled.div`
  display: flex;
  justify-content: center;
  font-size: 30px;
  padding: 12px 0;
  background: white;
  font-weight: 600;
  padding-bottom: 30px;
  z-index: 2;
  position: relative;
  @media (max-width: 767px) {
    font-size: 16px;
    padding-bottom: 32px;
  }
`

export const ConvenienceTitle = styled.div`
  font-family: 'Bebas Neue', sans-serif;
  display: flex;
  justify-content: center;
  position: relative;
  z-index: 2;
  background: ${WHITE};
  padding-top: 40px;
  font-weight: 600;
  padding-bottom: 12px;
  font-size: 52px;
  color: ${BLACK};
  text-align: center;
  @media (max-width: 767px) {
    font-size: 26px;
    padding-left: 4px;
    padding-right: 4px;
  }
`

export const ConvenienceText = styled.div`
  font-size: 25px;
  display: flex;
  justify-content: center;
  margin-bottom: -60px;
  position: relative;
  z-index: 2;
  background: ${WHITE};
  color: ${BLACK};
  text-align: center;
  @media (max-width: 767px) {
    margin-bottom: 0;
    font-size: 20px;
    padding-right: 4px;
    padding-left: 4px;
  }
`

export const PropositionTilesContainer = styled.div`
  background-color: ${AUBERGINE};
  color: ${WHITE};
  display: flex;
  justify-content: space-evenly;
  padding: 21px 0 29px;

  @media (min-width: 320px) and (max-width: 767px) {
    flex-direction: column;
    height: 401px;
    padding: 0;
  }
`

export const PropositionTile = styled.div`
  color: ${WHITE};
  font-size: 20px;
  letter-spacing: 0.25px;
  line-height: 27px;
  text-align: center;
`

export const SubText = styled.div`
  color: ${GRAY_SOFT};
  font-size: 14px;
`

export const layoutStyle = {
  background: WHITE
}

export const CarouselContainer = styled.div`
  order: ${({ order }: DivProps) => order || 3};
  text-align: center;
  & .slick-prev {
    margin-left: 30px;
  }
  & .slick-next {
    margin-right: 20px;
  }

  .slick-dots{
    bottom: 8px;
  }
  .slick-dots li button {
    height: 0;
  }
  .slick-dots li button:before {
    background: ${WHITE};
    border-radius: 100px;
    border: 1px solid ${BLACK};
    box-shadow: 0 0 1px 4px 2px ${WHITE};
    content: '';
    height: 12px;
    width: 12px;
    margin-top: 4px;
    opacity: 0.8 !important;
  }
  .slick-dots li.slick-active button:before {
    background: ${BLACK};
    border: 1px solid white;
  }
  img {
    display: unset !important;
  }
`

export const SlideImageContainer = styled.div`
  order: ${({ order }: DivProps) => order || 'unset'};
  display: flex;
  justify-content: center;
  align-items: center;
`

export const SlideVideo = styled.video`
  width: 100%;
`

export const ImageContainer = styled.div`
  width: 100%;
`

export const SlideImage = styled.img`
  width: 100%;
  display: inline-block;
  @media (max-width: 425px) {
    display: none;
  }
`
export const SlideImageMobile = styled.img`
  width: 100%;
  display: none;
  @media (max-width: 425px) {
    display: inline-block;
  }
`
export const DeliveryInfo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`
interface MonthProps {
  currentMonth?: boolean
}

export const Calendar = styled.div`
  margin-top: 5px;
  border: 2px solid
    ${({ currentMonth }: MonthProps) => (currentMonth ? RED : GREEN)};
  width: 90px;
  height: 90px;
  background: ${WHITE};
  color: ${BLACK};
  @media (max-width: 400px) {
    height: 50px;
    width: 60px;
  }
`

export const Month = styled.div`
  font-size: 13px;
  background: ${({ currentMonth }: MonthProps) => (currentMonth ? RED : GREEN)}
  text-align: center;
  color: ${WHITE};
  text-transform: uppercase;
  font-weight: 600;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 400px) {
    font-size: 10px;
    height: 15px;
  }
`

export const Day = styled.div`
  font-size: 36px;
  text-align: center;
  font-weight: 600;
  height: 63px;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 400px) {
    height: 30px;
    font-size: 20px;
  }
`

export const OrderInfo = styled.div`
  display: flex;
  flex-flow: column;
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  align-items: center;
  color: ${BLACK};
  @media (max-width: 400px) {
    font-size: 8px;
  }
`

export const HeaderInfo = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 16px;
  text-transform: uppercase;
  text-align: center;
  margin: 0 90px;
  color: ${BLACK};
  @media (max-width: 600px) {
    margin: 0 10px;
  }
  @media (max-width: 400px) {
    margin: 0;
    font-size: 11px;
  }
`

export const NumberOfDays = styled.div`
  font-weight: 600;
  font-size: 18px;
  font-family: ${AVENIR_MEDIUM};
  margin: 0px 0;
  font-weight: 900;
  @media (max-width: 400px) {
    font-size: 12px;
  }
`

export const CalendarLabel = styled.div`
  font-weight: 400;
  font-size: 16px;
  text-transform: none;
  font-family: ${AVENIR_NEXT};
  color: ${RED}
  margin: 0px 0;
  @media (max-width: 400px) {
    font-size: 12px;
  }
`

export const OrderingInfo = styled.div`
  font-size: 13px;
  text-transform: none;
  font-style: italic;
  @media (max-width: 600px) {
    margin-top: 10px;
  }
  @media (max-width: 400px) {
    font-size: 9px;
  }
`

export const DeliveryContainer = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  background: ${GRAY_LIGHTEST};
  text-align: center;
  color: ${BLACK};
  order: ${({ order }: DivProps) => order || 3};
  @media (max-width: 600px) {
    width: 100%;
    overflow: hidden;
  }
`

export const HeaderInfoTitle = styled.div`
  display: flex;
  font-weight: 600;
  letter-spacing: 0.5px;
  width: 250px;
  margin-bottom: 5px;
  @media (max-width: 600px) {
    font-size: 12px;
    width: 200px;
  }
  @media (max-width: 400px) {
    font-size: 10px;
    width: 180px;
  }
`

export const InfoIcon = styled.img`
  height: 32px;
  position: absolute;
  left: calc(50% + 120px);
  top: 6px;
  z-index: 9;
  filter: drop-shadow(0px 2px 2px ${GRAY_DARK});
  ${({ secondary }: DivProps) => secondary ? `
    animation: wobble-hor-bottom 1s 0.5s 4 both;
    @keyframes wobble-hor-bottom {
      0%, 20%, 50%, 80%, 100% {transform: translateY(0);}
      40% {transform: translateY(-20px);}
      60% {transform: translateY(-7px);}
    }
  ` : ''}
`

export const Structure = styled.div`
  display: flex;
  flex-flow: column;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/Home/styledComponents.tsx